webpackJsonp([6],{

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Styles_common_less__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Styles_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Styles_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_card_card_less__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_card_card_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_Components_card_card_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_info_number_info_number_less__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_info_number_info_number_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Components_info_number_info_number_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_icon_list_icon_list_less__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_icon_list_icon_list_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_Components_icon_list_icon_list_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_section_header_section_header_less__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_section_header_section_header_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Components_section_header_section_header_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_figure_list_figure_list_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Components_figure_list_figure_list_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_Components_figure_list_figure_list_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_list_list_less__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Components_list_list_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_Components_list_list_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_WebComponents_tabs_tabs_less__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_WebComponents_tabs_tabs_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_WebComponents_tabs_tabs_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__links_links_less__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__links_links_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__links_links_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directions_directions_less__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directions_directions_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__directions_directions_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calculator_calculator_less__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__calculator_calculator_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__calculator_calculator_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__timing_timing_less__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__timing_timing_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__timing_timing_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__stuff_stuff_less__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__stuff_stuff_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__stuff_stuff_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__advantages_advantages_less__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__advantages_advantages_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__advantages_advantages_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__license_license_less__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__license_license_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__license_license_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_WebComponents_greedy_nav__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__slider__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_WebComponents_a11y__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_WebComponents_calculator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_promise__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_promise__);






















var a11y = new __WEBPACK_IMPORTED_MODULE_17_WebComponents_a11y__["a" /* A11y */]();


var calculatorExams = new __WEBPACK_IMPORTED_MODULE_18_WebComponents_calculator__["a" /* CalculatorExams */]();


if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_promise___default.a;
}

var componentContext = [__webpack_require__(92)];
document.addEventListener('DOMContentLoaded', function () {
  componentContext.forEach(function (context) {
    context(function () {});
  });
  a11y.init();
  calculatorExams.init();
});

var iconsContext = __webpack_require__(88);
// TODO: replace event from onload to onscroll to container
window.addEventListener('load', function () {
  iconsContext(function () {});
});

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
__webpack_require__(28);
__webpack_require__(67);
__webpack_require__(163);
__webpack_require__(165);
module.exports = __webpack_require__(2).Set;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(33);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(10)
  , IObject  = __webpack_require__(49)
  , toObject = __webpack_require__(27)
  , toLength = __webpack_require__(26)
  , asc      = __webpack_require__(142);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16)
  , isArray  = __webpack_require__(71)
  , SPECIES  = __webpack_require__(0)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(141);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(3).f
  , create      = __webpack_require__(55)
  , redefineAll = __webpack_require__(57)
  , ctx         = __webpack_require__(10)
  , anInstance  = __webpack_require__(44)
  , defined     = __webpack_require__(32)
  , forOf       = __webpack_require__(33)
  , $iterDefine = __webpack_require__(52)
  , step        = __webpack_require__(72)
  , setSpecies  = __webpack_require__(76)
  , DESCRIPTORS = __webpack_require__(7)
  , fastKey     = __webpack_require__(54).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(45)
  , from    = __webpack_require__(138);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(1)
  , $export        = __webpack_require__(9)
  , meta           = __webpack_require__(54)
  , fails          = __webpack_require__(18)
  , hide           = __webpack_require__(11)
  , redefineAll    = __webpack_require__(57)
  , forOf          = __webpack_require__(33)
  , anInstance     = __webpack_require__(44)
  , isObject       = __webpack_require__(16)
  , setToStringTag = __webpack_require__(25)
  , dP             = __webpack_require__(3).f
  , each           = __webpack_require__(140)(0)
  , DESCRIPTORS    = __webpack_require__(7);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(143);

// 23.2 Set Objects
module.exports = __webpack_require__(145)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(9);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(144)('Set')});

/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(37);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
__webpack_require__.e/* require.ensure */(1).then((function(require) {
	data = __webpack_require__(115);
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(65);
module.exports = __webpack_require__(2).Array.from;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(3)
  , createDesc      = __webpack_require__(19);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(10)
  , $export        = __webpack_require__(9)
  , toObject       = __webpack_require__(27)
  , call           = __webpack_require__(51)
  , isArrayIter    = __webpack_require__(50)
  , toLength       = __webpack_require__(26)
  , createProperty = __webpack_require__(46)
  , getIterFn      = __webpack_require__(64);

$export($export.S + $export.F * !__webpack_require__(53)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_src_less_swiper_less__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_src_less_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_src_less_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_less__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slider_less__);
/* eslint no-unused-vars: "off" */



window.addEventListener('load', function () {
  var swiperContext = __webpack_require__(41);

  swiperContext(function (Swiper) {
    var admissionSlider = new Swiper('.swiper-container.c-admission-slider__container', {
      effect: 'fade',
      simulateTouch: false,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev'
    });
  });
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalculatorExams; });





var CalculatorExams = function () {
  function CalculatorExams() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CalculatorExams);

    this.name = {
      form: 'calculatorExams',
      total: '.c-info-number__value'
    };
    this.MAX_NUMBERS_OF_EXAMS = 3;
    this.inputs = [];
    this.button = null;
    this.form = null;
    this.exams = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
    this.totalCountLabel = null;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CalculatorExams, [{
    key: 'init',
    value: function init() {
      this.form = document.forms[this.name.form];
      if (!!this.form) {
        var _arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.form.elements));
        this.button = _arr.splice(-1);
        this.inputs = _arr.slice(0, _arr.length - 1);
        this.totalCountLabel = this.form.querySelector(this.name.total);
        this.totalCountLabel.innerText = '0'; //'&#8734;'

        this.form.addEventListener('input', this._onValueChange.bind(this));
      }
    }
  }, {
    key: '_onValueChange',
    value: function _onValueChange() {
      var _this = this;

      var total = 0;

      this.inputs.forEach(function (item) {
        _this._updateDisabledInputs();

        if (item.value !== '') {
          _this.exams.add(item.name);
          total += parseInt(item.value);
        } else {
          _this.exams.delete(item.name);
        }
      });
      this.totalCountLabel.innerText = total;
      //this.exams.forEach((value, valueAgain, set) => {
      //console.log(value, set.size);
      //});
    }
  }, {
    key: '_updateDisabledInputs',
    value: function _updateDisabledInputs() {
      var _this2 = this;

      this.inputs.forEach(function (input) {
        if (_this2.exams.size >= _this2.MAX_NUMBERS_OF_EXAMS && !_this2.exams.has(input.name)) {
          input.setAttribute('disabled', 'true');
          input.value = '';
        } else {
          input.removeAttribute('disabled');
        }
      });
    }
  }]);

  return CalculatorExams;
}();



/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(3).then((function(require) {
		cb(__webpack_require__(211));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
__webpack_require__.e/* require.ensure */(0).then((function(require) {
	data = __webpack_require__(116);
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[117]);


// WEBPACK FOOTER //
// admission.js